/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Zotero_Browser_Importable_OnlyInputs */

const en_zotero_browser_importable_only = /** @type {(inputs: Zotero_Browser_Importable_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show importable only`)
};

const es_zotero_browser_importable_only = /** @type {(inputs: Zotero_Browser_Importable_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostrar solo importables`)
};

/**
* | output |
* | --- |
* | "Show importable only" |
*
* @param {Zotero_Browser_Importable_OnlyInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const zotero_browser_importable_only = /** @type {((inputs?: Zotero_Browser_Importable_OnlyInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Zotero_Browser_Importable_OnlyInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_zotero_browser_importable_only(inputs)
	return en_zotero_browser_importable_only(inputs)
});